import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';

const PriceChangesAnnouncementLayout = (): JSX.Element => (
  <Stack
    justify='center'
    align='center'
  >
    <Typography
      type='paragraph'
      size='md'
      textAlign='center'
      color='text-white'
      fontWeight='font-weight-semibold'
    >
      Prices on Community, Courses, and Business are going up on August 1st—lock in the lowest rate now
    </Typography>
  </Stack>
);

export default PriceChangesAnnouncementLayout;
